module.exports = __webpack_public_path__ + "tl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tl.svg
// module id = 1099
// module chunks = 0